import React, { useEffect, useState } from "react";
import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
    Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Avatar,
  Box,
  Divider,
} from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import QuizIcon from "@mui/icons-material/Quiz";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useNavigate } from "react-router-dom";
import LogoutIcon from '@mui/icons-material/Logout';
import { useLocation } from "react-router-dom";
import { clearToken } from "../utils/Authe";
import { useTheme as useMuiTheme } from '@mui/material/styles';
import { useThemeMode  } from "../context/ThemeContext";
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

const StudentSidebar = ({ children }) => {
  const navigate = useNavigate();
  const [studentName, setStudentName] = useState("Student");
const location = useLocation();
const [activeItem, setActiveItem] = useState(null);
const [logoutConfirmOpen, setLogoutConfirmOpen] = useState(false);
const muiTheme = useMuiTheme();
const { mode, toggleTheme } = useThemeMode();

useEffect(() => {
  const path = location.pathname;
  if (path.includes("/student-dashboard")) setActiveItem("dashboard");
  else if (path.includes("/student-quizzes")) setActiveItem("quizzes");
  else if (path.includes("/student-results")) setActiveItem("results");
  else if (path.includes("/student-profile")) setActiveItem("profile");
  else setActiveItem(null);
}, [location]);

  useEffect(() => {
    const name = sessionStorage.getItem("student_name");
    if (name) {
      setStudentName(name);
    }
  }, []);

 const handleLogout = async () => {
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const clientCode = sessionStorage.getItem('clientCode');
  try {
    const response = await fetch(`${baseUrl}/student/logout/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${sessionStorage.getItem("student_token")}`,
      },
    });
    if (response.ok) {
      clearToken("student_token");
      sessionStorage.removeItem("student_id");
      sessionStorage.removeItem("student_name");
      // Redirect to login with the same client code
      navigate(`/login?client-code=${clientCode}`);
    } else {
      console.error("Logout failed");
    }
  } catch (error) {
    console.error("Error during logout:", error);
  }
};



  return (
    <>
      {/* Left Sidebar */}
      <Drawer
        variant="permanent"
       sx={{
    width: 260,
    flexShrink: 0,
    "& .MuiDrawer-paper": {
      width: 260,
      background: muiTheme.palette.mode === 'light' 
        ? "linear-gradient(135deg, #f8f9ff 0%, #f0f4ff 100%)"
        : "linear-gradient(135deg, #1e293b 0%, #0f172a 100%)",
      boxShadow: "0 20px 60px rgba(0, 0, 0, 0.05)",
      borderRight: `1px solid ${muiTheme.palette.divider}`,
    },
  }}
      >
        {/* Top Gradient Section */}
       <Box
  sx={{
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    color: "white",
    padding: "20px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  }}
>
  <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
    <Avatar sx={{ bgcolor: "white", color: "#667eea" }}>🎓</Avatar>
    <Tooltip title={mode === 'light' ? 'Dark Mode' : 'Light Mode'} arrow placement="right">
      <IconButton
        onClick={toggleTheme}
        sx={{ 
          color: 'white',
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
          },
        }}
      >
        {mode === 'light' ? <Brightness4Icon /> : <Brightness7Icon />}
      </IconButton>
    </Tooltip>
  </Box>
  <Typography variant="h6" sx={{ fontWeight: "bold" }}>
    Welcome, {studentName}!
  </Typography>
</Box>

        {/* Navigation Links */}
        <List sx={{ mt: 2, px: 1 }}>
          <ListItem disablePadding sx={{ mb: 1 }}>
            <ListItemButton
              onClick={() => {navigate("/student-dashboard");
                setActiveItem("dashboard");
              }}
              sx={{
  borderRadius: "12px",
  background: activeItem === "dashboard" ? "rgba(102, 126, 234, 0.2)" : "transparent",
  "&:hover": {
    background: "rgba(102, 126, 234, 0.1)",
  },
}}
            >
              <ListItemIcon>
                <HomeIcon sx={{ color: muiTheme.palette.primary.main }} />
              </ListItemIcon>
              <ListItemText
                primary="Dashboard"
                primaryTypographyProps={{ 
    fontWeight: "600", 
    color: muiTheme.palette.text.primary 
  }}
              />
            </ListItemButton>
          </ListItem>

          <ListItem disablePadding sx={{ mb: 1 }}>
            <ListItemButton
              onClick={() =>{ navigate("/student-quizzes");
                setActiveItem("quizzes")
              }}
             sx={{
  borderRadius: "12px",
  background: activeItem === "quizzes" ? "rgba(102, 126, 234, 0.2)" : "transparent",
  "&:hover": {
    background: "rgba(102, 126, 234, 0.1)",
  },
}}

            >
              <ListItemIcon>
                <QuizIcon sx={{ color: muiTheme.palette.primary.main }} />
              </ListItemIcon>
              <ListItemText
                primary="My Quizzes"
              primaryTypographyProps={{ 
    fontWeight: "600", 
    color: muiTheme.palette.text.primary 
  }}
              />
            </ListItemButton>
          </ListItem>

          <ListItem disablePadding sx={{ mb: 1 }}>
            <ListItemButton
              onClick={() => {navigate("/student-results");
                 setActiveItem("results");
              }}
             sx={{
  borderRadius: "12px",
  background: activeItem === "results" ? "rgba(102, 126, 234, 0.2)" : "transparent",
  "&:hover": {
    background: "rgba(102, 126, 234, 0.1)",
  },
}}

            >
              <ListItemIcon>
                <EmojiEventsIcon sx={{ color: muiTheme.palette.primary.main }} />
              </ListItemIcon>
              <ListItemText
                primary="My Results"
               primaryTypographyProps={{ 
    fontWeight: "600", 
    color: muiTheme.palette.text.primary 
  }}
              />
            </ListItemButton>
          </ListItem>

         <Divider sx={{ my: 2, bgcolor: muiTheme.palette.divider }} />

          <ListItem disablePadding>
            <ListItemButton
              onClick={() => {navigate("/student-profile");
                  setActiveItem("profile");

              }}
            sx={{
  borderRadius: "12px",
  background: activeItem === "profile" ? "rgba(102, 126, 234, 0.2)" : "transparent",
  "&:hover": {
    background: "rgba(102, 126, 234, 0.1)",
  },
}}

            >
              <ListItemIcon>
                <AccountCircleIcon sx={{ color: muiTheme.palette.primary.main }} />
              </ListItemIcon>
              <ListItemText
                primary="Profile"
                primaryTypographyProps={{ 
    fontWeight: "600", 
    color: muiTheme.palette.text.primary 
  }}
              />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
               onClick={() => setLogoutConfirmOpen(true)}
              sx={{
                borderRadius: "12px",
                "&:hover": {
                  background: "rgba(102, 126, 234, 0.1)",
                },
              }}
            >
              <ListItemIcon>
                <LogoutIcon sx={{ color: "red" }} />
              </ListItemIcon>
              <ListItemText
                primary="Logout"
                primaryTypographyProps={{ 
    fontWeight: "600", 
    color: muiTheme.palette.text.primary 
  }}
              />
            </ListItemButton>
          </ListItem>
        </List>
      </Drawer>

      {/* Main Content */}
    <Box
  sx={{
    marginLeft: "260px",
    width: "calc(100% - 260px)",
    minHeight: "100vh",
    background: muiTheme.palette.background.default,
  }}
>
  {children}
</Box>

      <Dialog
  open={logoutConfirmOpen}
  onClose={() => setLogoutConfirmOpen(false)}
  aria-labelledby="logout-confirm-dialog-title"
  aria-describedby="logout-confirm-dialog-description"
  maxWidth="xs"
  fullWidth
>
  <DialogTitle id="logout-confirm-dialog-title" sx={{ fontWeight: "bold", color: "error.main" }}>
    Confirm Logout
  </DialogTitle>
  <DialogContent dividers>
    <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
      <LogoutIcon sx={{ color: "error.main", mr: 1 }} />
      <Typography variant="body1" sx={{ fontWeight: "medium" }}>
        Are you sure you want to logout?
      </Typography>
    </Box>
    <Typography
      variant="body2"
      sx={{
        mt: 1,
        p: 1.5,
        backgroundColor: "error.lighter",
        borderRadius: 1,
        borderLeft: "4px solid",
        borderColor: "error.main",
        color: "error.dark",
      }}
    >
      <strong>Note:</strong> You will need to log in again to access your account.
    </Typography>
  </DialogContent>
  <DialogActions sx={{ p: 2, justifyContent: "space-between" }}>
    <Button
      onClick={() => setLogoutConfirmOpen(false)}
      variant="outlined"
      color="inherit"
      sx={{ borderColor: "grey.400" }}
    >
      Cancel
    </Button>
    <Button
      onClick={handleLogout}
      variant="contained"
      color="error"
      autoFocus
      startIcon={<LogoutIcon />}
      sx={{ boxShadow: "none" }}
    >
      Logout
    </Button>
  </DialogActions>
</Dialog>

    </>
  );
};

export default StudentSidebar;
